import metrics from '../../browser/metrics';
import { useScript } from '../hooks/useScript';
import { CookieConsentLevel, hasRequiredLevel } from './util';
var REQUIRED_CONSENT_LEVEL = CookieConsentLevel.Functional;
var scriptAttributes = {
    async: true,
    type: 'text/javascript',
    src: '//cdn2.auth0.com/js/m/metrics-1.min.js',
    onload: function () {
        metrics.init();
    },
};
export var useMetrics = function (currentConcents) {
    var hasConsent = hasRequiredLevel(currentConcents, REQUIRED_CONSENT_LEVEL);
    useScript('head', scriptAttributes, hasConsent);
};
export var Metrics = function (_a) {
    var currentConcents = _a.currentConcents;
    useMetrics(currentConcents);
    return null;
};
